import React from 'react'
import { Paper, Grid } from '@mui/material';
import DeptAddFormContainer from './DeptAddFormContainer'

const DepartRootContainer = ({type}) => {
  return (
   <>
    <Paper
      sx={{
        display: 'flex',
        flexDirection: 'column',
        mt: 1,
        px: 2,
      }}
    >
     <Grid
        container
        direction="row"
        justifyContent="flex-start"
        alignItems="center"
        spacing={1}
        sx={{ py: 1}}
      >
        <Grid item xs={2} >
          회사
        </Grid>
        <Grid item xs={10} >
         KMES
        </Grid>
      </Grid>
    </Paper>
    <DeptAddFormContainer type={type}/>
   </>
  )
}

export default DepartRootContainer